import { Component, OnInit } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  showChat:boolean = false;
  showChatWindow = false;
  openSettingSidebar: boolean = false


  // getChatOpen(message:boolean){
  //   this.showChat = message;
  // }
  // getChatclose(message:boolean){
  //   this.showChat = message;
  // }
  // getopenChatWindow(message:boolean){
  //   this.showChatWindow = message;
  // }

  
  constructor() { }

  ngOnInit(): void {
     
  }




}
